import React, { useCallback, useMemo, useState } from "react";
import "styles/legacy/HomeLanding.css";
import { HomeLandingModel } from "./HomeLandingModel";
import HomeLandingHeader from "./HomeLandingHeader";
import HomeLandingHero from "./HomeLandingHero";
import NewestReleasesSection from "./NewestReleasesSection";
import { EmptySearchState } from "../EmptySearchState/EmptySearchState";

export default function HomeLanding({
  model,
}: {
  model: HomeLandingModel;
}) {
  const [searchTerm, setSearchTerm] = useState("");

  const filteredReleases = useMemo(() => {
    const term = searchTerm.trim().toLowerCase();
    if (!term) return model.newestReleases;

    return model.newestReleases.filter((release) => {
      const inTitle = release.title.toLowerCase().includes(term);
      const inDescription = (release.description ?? "").toLowerCase().includes(term);
      const inRole = release.role.toLowerCase().includes(term);
      const inPrice = (release.price ?? "").toLowerCase().includes(term);
      const inPicks = release.picks.some(
        (pick) =>
          pick.label.toLowerCase().includes(term) ||
          pick.value.toLowerCase().includes(term)
      );

      return inTitle || inDescription || inRole || inPrice || inPicks;
    });
  }, [model.newestReleases, searchTerm]);

  const clearSearch = useCallback(() => {
    setSearchTerm("");
  }, []);

  const isSearchActive = searchTerm.trim().length > 0;
  const showEmptySearch = isSearchActive && filteredReleases.length === 0;

  return (
    <div className="homeLandingRoot">
      <HomeLandingHeader
        searchTerm={searchTerm}
        onSearchChange={setSearchTerm}
      />
      {showEmptySearch ? (
        <EmptySearchState onClearSearch={clearSearch} className="homeLandingEmptySearch" />
      ) : (
        <>
          <HomeLandingHero
            heroBgSrc={model.heroBgSrc}
            heroTextTitle={model.heroTextTitle}
            heroTextSubtitle={model.heroTextSubtitle}
          />
          <NewestReleasesSection
            title={model.newestReleasesTitle}
            newestReleases={filteredReleases}
          />
        </>
      )}
    </div>
  );
}

